import { QidProduct } from "server/models"
import { PublishedUnpublished, OrderType, QidType, ProvenType } from "client/utils"

export interface QidProductListProps {
    companyId?: number
}
export interface QidProductProps {
    productId: number
    hash?: string
}

export interface QidProductList { [productId: number]: QidProduct }
export interface QidProductFilters {
    companyId?: number
    name?: string
    type?: QidType
    lowDemandMode?: boolean
    highDemandMode?: boolean
    continuousMode?: boolean
    logicSolver?: boolean
    provenInUse?: ProvenType
    status?: PublishedUnpublished
    search?: string
}

export type QidProductValidation = { [key in keyof QidProduct]?: string }

export interface QidProductState {
    productList: QidProductList
    productIds: readonly number[]
    productView: QidProduct
    productEdit: QidProduct

    productFolderId: number

    sortColumn: keyof QidProduct
    sortOrder: OrderType
    filters: QidProductFilters

    reloadList: boolean
    reloadView: boolean
    reloadEdit: boolean
}

export const QID_PRODUCT_LIST = "QID_PRODUCT_LIST"
export const QID_PRODUCT_IDS = "QID_PRODUCT_IDS"
export const QID_PRODUCT_VIEW = "QID_PRODUCT_VIEW"
export const QID_PRODUCT_EDIT = "QID_PRODUCT_EDIT"

export const QID_PRODUCT_FOLDER_ID = "QID_PRODUCT_FOLDER_ID"

export const QID_PRODUCT_SORT = "QID_PRODUCT_SORT"
export const QID_PRODUCT_FILTERS = "QID_PRODUCT_FILTERS"

export const QID_PRODUCT_RELOAD_LIST = "QID_PRODUCT_RELOAD_LIST"
export const QID_PRODUCT_RELOAD_VIEW = "QID_PRODUCT_RELOAD_VIEW"
export const QID_PRODUCT_RELOAD_EDIT = "QID_PRODUCT_RELOAD_EDIT"
